import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomSelect from '../../common/formElements/CustomSelect';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XataWorkspacesList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    selectedWorkspace: '',
    errorMessage: '',
  };
  handleChange = (name, value) => {
    this.setState({ [name]: value.value });
  };
  handleSendRequset = async (value) => {
    const { actions, location, match, history } = this.props;
    const { state } = location;
    const { headers, dataSourceName } = state;
    const { projectId, version } = match.params;
    const { selectedWorkspace } = this.state;
    if (!selectedWorkspace) {
      this.setState({ errorMessage: 'Please Choose Any Workspace !' });
    }
    await actions.getDatabasesForXata({
      headers,
      workspaceId: selectedWorkspace,
      projectId,
      version,
    });
    if (this.props.dataConnector.databasesByXata) {
      history.push(`/data-connector/${version}/v/${projectId}/xata-databases`, {
        headers,
        dataSourceName,
        workspaceId: selectedWorkspace,
      });
    }
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { dataConnector, history, match } = this.props;
    const { projectId, version } = match.params;
    const { workSpaceByXata, getDatabasesForXataPending } = dataConnector;
    const { errorMessage, selectedWorkspace } = this.state;
    if (!workSpaceByXata) {
      history.push(`/data-connector/${version}/v/${projectId}/xata-datasource`);
    }
    const dropdown = workSpaceByXata
      ? workSpaceByXata.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      : null;

    return (
      <CommonPageComponent>
        <ParentContentCard title={'Choose Workspace for Database'} icon="collection">
          <div className="row justify-content-center ">
            <div className="col-sm-4">
              <CustomSelect
                name="selectedWorkspace"
                isMulti={false}
                isObject={true}
                options={dropdown}
                value={selectedWorkspace}
                placeholder="Select Workspace"
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="text-center ml-3">
            {errorMessage && <p className="errors">{errorMessage}</p>}
          </div>
          <div className="text-center ml-3 mt-2">
            <button
              className="btn btn-theme-submit mt-3"
              onClick={this.handleSendRequset}
              disabled={getDatabasesForXataPending}
            >
              <i className="wb webconnect-rocket"></i>
              &nbsp;Continue&nbsp;
              <CustomLoader loading={getDatabasesForXataPending} />
            </button>
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XataWorkspacesList);
